module.exports = __webpack_public_path__ + "media/images/writer-offering-policy03-2d5c42f96cc253f9e4a4e2e69c7ce17e.png";